import { createMeta } from '@exodus/trezor-meta';
import { combine, compute } from '@exodus/atoms';
import { mapValues, intersection } from '@exodus/basic-utils';
import memoize from 'lodash/memoize';
const memoizedGetTrezorAvailableAssets = memoize((assetsValue, model, availableAssetNames) => {
    const { ASSETS_BY_MODEL } = createMeta(assetsValue);
    return intersection(ASSETS_BY_MODEL[model] || ASSETS_BY_MODEL.T, availableAssetNames);
}, (assetsValue, model, availableAssetNames) => `${Object.keys(assetsValue).join(',')}_${model}_${availableAssetNames.join(',')}`);
const createAvailableAssetNamesByWalletAccountAtom = ({ assetsAtom, availableAssetNamesAtom, enabledWalletAccountsAtom, }) => compute({
    atom: combine({
        walletAccounts: enabledWalletAccountsAtom,
        availableAssetNames: availableAssetNamesAtom,
        assets: assetsAtom,
    }),
    selector: ({ assets, walletAccounts, availableAssetNames }) => {
        return mapValues(walletAccounts, ({ source, model }) => {
            if (source === 'trezor') {
                return memoizedGetTrezorAvailableAssets(assets.value, model, availableAssetNames);
            }
            return availableAssetNames;
        });
    },
});
export const availableAssetNamesByWalletAccountAtomDefinition = {
    id: 'availableAssetNamesByWalletAccountAtom',
    type: 'atom',
    factory: createAvailableAssetNamesByWalletAccountAtom,
    dependencies: ['assetsAtom', 'availableAssetNamesAtom', 'enabledWalletAccountsAtom'],
    public: true,
};
